export default "__VITE_ASSET__BWfhuyej__"